module.exports = __webpack_public_path__ + "static/media/suitcase.bb512e49.svg";